import SVGWrapper from './SVGWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const SVGImage = props => {
  return /*#__PURE__*/_jsx(SVGWrapper, Object.assign({}, props, {
    "data-test-id": "avatar-svg-image"
  }));
};
export default SVGImage;